<template lang="pug">
#v-reward.reward.container
  h2.reward__title 填完資料，還可抽多重好禮
  .reward__list
    .reward__item.reward-item
      label.reward-item__prize 一獎
      h3.reward-item__name 小米行動電源高配版
      img(v-if='!$store.state.mobile', src='@/assets/reward-1.png', alt='小米行動電源高配版', width='280')
      img(v-else, src='@/assets/m-reward-1.png', alt='小米行動電源高配版', width='200')
      .reward-item__number 金色 X 1名
    .reward__item.reward-item
      label.reward-item__prize 二獎
      h3.reward-item__name 小米隨身藍芽喇叭
      img(v-if='!$store.state.mobile', src='@/assets/reward-2.png', alt='小米行動電源高配版', width='280')
      img(v-else, src='@/assets/m-reward-2.png', alt='小米行動電源高配版', width='200')
      .reward-item__number 金屬銀 X 1名 香檳金 X 1名
    .reward__item.reward-item
      label.reward-item__prize 三獎
      h3.reward-item__name 小米金屬滑鼠墊
      img(v-if='!$store.state.mobile', src='@/assets/reward-3.png', alt='小米行動電源高配版', width='280')
      img(v-else, src='@/assets/m-reward-3.png', alt='小米行動電源高配版', width='200')
      .reward-item__number 小號銀色 X 2名
</template>

<script>
export default {
  name: 'Reward',
}
</script>

<style lang="sass" scoped>
.reward
  padding-bottom: 60px
  &__title
    +font(32px, #E50029, 32px, 2.13px, 500)
    margin-bottom: 60px
    text-align: center
    &::after
      border-bottom: 2px solid #E50029
      content: ''
      display: block
      margin-left: auto
      margin-right: auto
      padding-bottom: 34px
      width: 80px
  &__list
    +flexbox(space-between)
.reward-item
  text-align: center
  &__prize
    +circle(65px)
    +flexbox(center, center)
    +font(18px, #E50029)
    display: inline-flex
    border: 1px solid #E50029
    margin-bottom: 20px
  &__name
    +font(24px, black, 24px, 2px, 500)
    margin-bottom: 30px
  &__number
    +font(18px, #5A5A5A, 18px, .74px)
    margin-top: 20px

@media (max-width: 991px)
  .reward
    padding-bottom: 40px
    padding-top: 40px
    &__title
      +font(20px, null, 28px, 1px)
      margin-bottom: 40px
      &::after
        padding-bottom: 24px
        width: 55px
    &__list
      +flexbox(flex-start, center, column)
      margin-bottom: -40px
    &__item
      margin-bottom: 40px
  .reward-item
    &__prize
      +size(60px)
      font-size: 16px
      margin-bottom: 16px
    &__name
      +font(16px, null, 16px, 1.33px)
      margin-bottom: 20px
    &__number
      +font(14px, null, 14px, .58px)
      margin-top: 14px
</style>
